import { Component, OnInit } from '@angular/core';
import { ButtonStepComponent } from '../../step/button-step/button-step.component';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-current-va',
    templateUrl: '../../step/button-step/button-step.component.html',
    styleUrls: ['./current-va.component.scss', '../../step/step.component.scss', '../../step/button-step/button-step.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    standalone: false
})
export class CurrentVAComponent extends ButtonStepComponent implements OnInit {
  title : string = "Are you currently in a VA loan?";
  buttonList = [
    { text: 'Yes', value: 'yes', imageName: 'yes'},
    { text: 'No', value: 'no', imageName: 'no-x'},
    { text: "Don't Know", value: "no", imageName: 'dont-know', default: true}
  ];
  ngOnInit() {
    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('currentVA', this.control);
  }
}
